<script lang="ts" setup>
import { Info } from '@/@types/info'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { formatText } from '@/helpers/format-text'
import { FormSchema } from '@/pages/users/registrations/new.vue'
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

defineProps<{
    form: FormSchema
}>()

const billing_setor = inject<Info[]>('billing_setor')
const billing_area = inject<Info[]>('billing_area')
const billing_nivel_hierarquico = inject<Info[]>('billing_nivel_hierarquico')
</script>

<template>
    <div>
        <Label required for="first_name">{{ $t('First name') }}</Label>
        <Input
            id="first_name"
            type="name"
            :placeholder="t('First name')"
            v-model="form.first_name"
            @input="(e: Event) => (form.first_name = formatText((e.target as HTMLInputElement).value))"
        />
        <p class="text-destructive text-xs" v-if="form.errors.first_name">{{ form.errors.first_name }}</p>
    </div>

    <div>
        <Label required for="last_name">{{ $t('Last name') }}</Label>
        <Input
            id="last_name"
            type="name"
            :placeholder="t('Last name')"
            v-model="form.last_name"
            @input="(e: Event) => (form.last_name = formatText((e.target as HTMLInputElement).value))"
        />
        <p class="text-destructive text-xs" v-if="form.errors.last_name">{{ form.errors.last_name }}</p>
    </div>

    <div>
        <Label for="linkedin">Linkedin</Label>
        <Input id="linkedin" type="text" :placeholder="t('Linkedin')" v-model="form.billing_linkedin" />
        <p class="text-destructive text-xs" v-if="form.errors.billing_linkedin">{{ form.errors.billing_linkedin }}</p>
    </div>

    <div>
        <Label required for="email">{{ $t('Email') }}</Label>
        <Input id="email" type="email" :placeholder="t('Type your e-mail')" v-model="form.email" />
        <p class="text-destructive text-xs" v-if="form.errors.email">{{ form.errors.email }}</p>
    </div>

    <div>
        <Label required for="phone">{{ $t('Cell phone') }}</Label>
        <Input id="phone" type="tel" :placeholder="t('(00) 00000-0000')" v-model="form.phone" default-calling-code="BR" />
        <p class="text-destructive text-xs" v-if="form.errors.phone">{{ form.errors.phone }}</p>
    </div>

    <div>
        <Label required for="company">{{ $t('Company') }}</Label>
        <Input id="company" type="text" v-model="form.billing_empresa" :placeholder="t('Enter the company name')" />
        <p class="text-destructive text-xs" v-if="form.errors.billing_empresa">{{ form.errors.billing_empresa }}</p>
    </div>

    <div>
        <Label required for="">{{ $t('Sector') }}</Label>

        <Select v-model="form.billing_setor">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Select')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem v-for="setor in billing_setor" :value="setor.slug">
                    <template v-if="$i18n.locale === 'pt-BR'">
                        {{ setor.name }}
                    </template>
                    <template v-else>
                        {{ setor.name_en || setor.name }}
                    </template>
                </SelectItem>
            </SelectContent>
        </Select>
        <p class="text-destructive text-xs" v-if="form.errors.billing_setor">{{ form.errors.billing_setor }}</p>
    </div>

    <div>
        <Label required for="">{{ $t('Hierarchical Level') }}</Label>

        <Select v-model="form.billing_nivel_hierarquico">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Select')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem v-for="setor in billing_nivel_hierarquico" :value="setor.slug">
                    <template v-if="$i18n.locale === 'pt-BR'">
                        {{ setor.name }}
                    </template>
                    <template v-else>
                        {{ setor.name_en || setor.name }}
                    </template>
                </SelectItem>
            </SelectContent>
        </Select>
        <p class="text-destructive text-xs" v-if="form.errors.billing_nivel_hierarquico">{{ form.errors.billing_nivel_hierarquico }}</p>
    </div>

    <div>
        <Label required for="">{{ $t('Area') }}</Label>

        <Select v-model="form.billing_area">
            <SelectTrigger class="w-full">
                <SelectValue :placeholder="$t('Select')" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem v-for="setor in billing_area" :value="setor.slug">
                    <template v-if="$i18n.locale === 'pt-BR'">
                        {{ setor.name }}
                    </template>
                    <template v-else>
                        {{ setor.name_en || setor.name }}
                    </template>
                </SelectItem>
            </SelectContent>
        </Select>
        <p class="text-destructive text-xs" v-if="form.errors.billing_area">{{ form.errors.billing_area }}</p>
    </div>
</template>
